import { render, staticRenderFns } from "./online-hot.vue?vue&type=template&id=b0be679a&"
import script from "./online-hot.vue?vue&type=script&lang=js&"
export * from "./online-hot.vue?vue&type=script&lang=js&"
import style0 from "./online-hot.vue?vue&type=style&index=0&id=b0be679a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports